<template>
  <div v-if="show" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="disableUserModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 v-if="selectedUser.status==='Active'" class="modal-title">Disable {{getFirstName(selectedUser.names)}}</h5>
          <h5 v-if="selectedUser.status!=='Active'" class="modal-title">Activate {{getFirstName(selectedUser.names)}}</h5>
          <button type="button" class="btn-close" @click="$emit('close')" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-12 mb-3">
              <div class="form-group">
                <label for="" class="mb-0 pb-0">{{selectedUser.names}}</label>
                <p v-if="selectedUser.status==='Active'">
                  <small><b>{{getFirstName(selectedUser.names)}}'s</b> account will be disabled and he/she will not be able to login</small>
                </p>
                <p v-if="selectedUser.status!=='Active'">
                  <small><b>{{getFirstName(selectedUser.names)}}'s</b> account will be activated and he/she will be able to login</small>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button v-if="selectedUser.status==='Active'" @click="handleDisable('Disabled')" class="btn btn-danger w-100" title="Click to disable">Disable</button>
          <button v-if="selectedUser.status!=='Active'" @click="handleDisable('Active')" class="btn btn-success w-100" title="Click to activate">Activate</button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show"></div>
</template>

<script>
export default {
  name: "DisableUserModal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    selectedUser: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    getFirstName(fullName) {
      if (!fullName) return '';
      const firstName = fullName.split(" ")[0];
      return firstName.charAt(0).toUpperCase() + firstName.slice(1).toLowerCase();
    },

    handleDisable(status) {
      this.$emit('disable', status);
    }
  }
}
</script>